<nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
  <div class="container">
    <a class="navbar-brand fw-bold gradient-text" routerLink="/">
      <span class="fs-3">Koomzo</span>
    </a>
    
    <button 
      class="navbar-toggler border-0" 
      type="button" 
      (click)="toggleMenu()"
      [attr.aria-expanded]="isMenuOpen">
      <span class="navbar-toggler-icon"></span>
    </button>
    
    <div class="collapse navbar-collapse" [class.show]="isMenuOpen">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a 
            class="nav-link" 
            routerLink="/" 
            routerLinkActive="active" 
            [routerLinkActiveOptions]="{exact: true}"
            (click)="closeMenu()">
            {{ 'common.home' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            routerLink="/platform" 
            routerLinkActive="active"
            (click)="closeMenu()">
            {{ 'common.platform' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            routerLink="/products" 
            routerLinkActive="active"
            (click)="closeMenu()">
            {{ 'common.products' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            routerLink="/pricing" 
            routerLinkActive="active"
            (click)="closeMenu()">
            {{ 'common.pricing' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            routerLink="/blog" 
            routerLinkActive="active"
            (click)="closeMenu()">
            {{ 'common.blog' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            routerLink="/downloads" 
            routerLinkActive="active"
            (click)="closeMenu()">
            {{ 'common.downloads' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            routerLink="/contact" 
            routerLinkActive="active"
            (click)="closeMenu()">
            {{ 'common.contact' | translate }}
          </a>
        </li>
      </ul>
      <div class="d-lg-flex ms-lg-3 align-items-center gap-2">
        <!-- Language Switcher -->
        <div class="dropdown language-dropdown">
          <button 
            class="btn btn-outline-secondary btn-sm dropdown-toggle" 
            type="button" 
            (click)="toggleLanguageMenu($event)"
            [attr.aria-expanded]="isLanguageMenuOpen">
            <i class="bi bi-globe me-1"></i>
            {{ currentLanguage.toUpperCase() }}
          </button>
          <ul class="dropdown-menu dropdown-menu-end" [class.show]="isLanguageMenuOpen">
            <li *ngFor="let lang of availableLanguages">
              <a 
                class="dropdown-item" 
                [class.active]="currentLanguage === lang.value"
                (click)="changeLanguage(lang.value)">
                {{ lang.text }}
              </a>
            </li>
          </ul>
        </div>
        <a routerLink="/contact" class="btn btn-primary" (click)="closeMenu()">
          {{ 'common.getStarted' | translate }}
        </a>
      </div>
    </div>
  </div>
</nav>

